<template>
    <div class="flex-container">
        <div class="input-wrapper">
            <NumberInput ref="niIncome" v-model="income" description="Income" :optional="false" :min="Constants.MinAnnualIncome"
                :max="Constants.MaxAnnualIncome" @entered="onUpdateClicked"></NumberInput>
        </div>
        <div class="buttons-wrapper mt-3 mb-3">
            <button type="button" class="btn btn-primary float-end ms-2" @click="onUpdateClicked">Update</button>
            <button type="button" class="btn btn-secondary float-end" @click="emit('cancelled')">Cancel</button>
        </div>
    </div>
</template>

<script setup lang="ts">
import { ref } from "vue";
import NumberInput from "../common/NumberInput.vue";
import Constants from '@/guiide/ts/constants';

const emit = defineEmits({
    'updateYear': null,
    'cancelled': null
});

const niIncome = ref(null);
const income = ref(0);

function initialize() {
    niIncome.value.takeFocus();
}

function setIncome(annualIncome: number) {
    income.value = annualIncome;
}

defineExpose({ initialize, setIncome });

function onUpdateClicked() {
    if (!niIncome.value.isValid()) {
        return;
    }

    emit('updateYear', income.value);
}
</script>

<style scoped>
.flex-container {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
}

.input-wrapper {
    width: 100%;
}

.buttons-wrapper {
    display: flex;
    gap: 10px;
}
</style>